export const ValidationReason = {
    CONFIG_MISSING: "config_missing",
    TRIAL_DURATION_DAYS_INVALID: "trial_duration_days_invalid",
    REQUIRE_OPT_IN_INVALID: "require_opt_in_invalid",
    STEPS_INVALID: "steps_invalid",
    STEP_SHAPE_INVALID: "step_shape_invalid",
    STEP_ID_INVALID: "step_id_invalid",
    STEP_MIN_ELAPSED_DAYS_INVALID: "step_min_elapsed_days_invalid",
    STEP_MAX_ELAPSED_DAYS_INVALID: "step_max_elapsed_days_invalid",
    STEP_TITLE_INVALID: "step_title_invalid",
    STEP_BODY_INVALID: "step_body_invalid",
    STEP_BODY_ENTRY_INVALID: "step_body_entry_invalid",
    STEP_LINKS_INVALID: "step_links_invalid",
    STEP_SHOW_CLOSE_BUTTON_INVALID: "step_show_close_button_invalid",
    STEP_AUTO_DISMISS_MS_INVALID: "step_auto_dismiss_ms_invalid",
    STEP_ELEMENT_SHAPE_INVALID: "step_element_shape_invalid",
    STEP_ELEMENT_KEY_MISSING: "step_element_key_missing",
    STEP_I18N_EN_MISSING: "step_i18n_en_missing",
    STEP_I18N_ENTRIES_INVALID: "step_i18n_entries_invalid",
    STEP_I18N_VALUE_NOT_STRING: "step_i18n_value_not_string",
    STEP_I18N_KEY_MISSING_IN_EN: "step_i18n_key_missing_in_en",
    ACTION_SHAPE_INVALID: "action_shape_invalid",
    ACTION_TYPE_UNKNOWN: "action_type_unknown",
    NAVIGATE_URL_MISSING: "navigate_url_missing",
    NAVIGATE_URL_NOT_ALLOWLISTED: "navigate_url_not_allowlisted",
    URL_VALIDATION_FAILED_AFTER_SUBSTITUTION: "url_validation_failed_after_substitution",
};
